import { render, staticRenderFns } from "./MenuPartThree.vue?vue&type=template&id=19a591dc&scoped=true"
import script from "./MenuPartThree.vue?vue&type=script&lang=js"
export * from "./MenuPartThree.vue?vue&type=script&lang=js"
import style0 from "./MenuPartThree.vue?vue&type=style&index=0&id=19a591dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a591dc",
  null
  
)

export default component.exports